export default __webpack_public_path__ + "static/media/7.53de5aed.png";